export function getFootprintAsset(footprintBakedRules, assets) {
    return Object.values(assets).find((asset) => asset.name === footprintBakedRules.asset?.value?.toString());
}
//# sourceMappingURL=getFootprintAsset.js.map